import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SALE_DIRECTION, SaleModel} from "../../entity/sale.model";
import {IDialogComponent} from "../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../common/dialog/dialogWithInput";
import {DialogModule} from "../../../../common/dialog/dialog.module";
import {SaleSaveProductFormModule} from "../sale-save-product-form/sale-save-product-form.module";
import {PRODUCT_TYPE} from "../../../../product/api/entity/product.model";
import {
  FormBuilder,
  FormGroup,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {SaleSummaryModel} from "../../entity/saleSummary.model";
import {ButtonModule} from "../../../../core/component/button/button.module";
import {SaleAddSaleProductActionService} from "../../../impl/service/saleAddSaleProductAction.service";
import {SaleProductSummaryModel} from "../../../modules/product/api/entity/saleProductSummary.model";
import {BaseView} from "../../../../core/view/base.view";
import {SaleSavePayloadProduct} from "../../../impl/service/payload/save/saleSavePayloadProduct.payload";

export interface SaleProductAddDialogInput {
  sale: SaleSummaryModel;

}

@Component({
  selector: 'app-sale-product-add-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, SaleSaveProductFormModule, ButtonModule],
  templateUrl: './sale-product-add-dialog.component.html',
  providers: [
    SaleAddSaleProductActionService
  ]
})
export class SaleProductAddDialogComponent extends BaseView implements IDialogComponent<SaleProductAddDialogInput, SaleProductSummaryModel>, OnInit{
  dialog: DialogWithInput<SaleProductAddDialogInput, SaleProductSummaryModel>;

  productType: PRODUCT_TYPE;
  formGroup: FormGroup;

  constructor(private formBuilder: FormBuilder,
              public service: SaleAddSaleProductActionService) {
    super();
    // TODO must be created in child component TODO-2025-04-01
    this.formGroup = this.formBuilder.group({
      id: new UntypedFormControl(undefined),
      productId: new UntypedFormControl(undefined, Validators.required),
      taxPercentage: new UntypedFormControl(0, this.isSimple ? [] : Validators.required),
      quantity: new UntypedFormControl(1, Validators.required),
      unitPriceVatExcluded: new UntypedFormControl(0, this.isSimple ? [] : Validators.required),
      unitPriceVatIncluded: new UntypedFormControl(0, this.isSimple ? [] : Validators.required),
      totalPriceVatExcluded: new UntypedFormControl(0, this.isSimple ? [] : Validators.required),
      totalPriceVatIncluded: new UntypedFormControl(0, Validators.required),
      deposit: new UntypedFormControl(0, Validators.required),
      productChanged: new UntypedFormControl(false, Validators.required),
    });
    this.formGroup.controls.totalPriceVatExcluded.disable();
    this.formGroup.controls.totalPriceVatIncluded.disable();
    this.formGroup.valueChanges.subscribe(() => {
      // this.updateTotalPrices();
    });
  }


  ngOnInit(): void {
    this.productType = this.dialog.input.sale.direction.value === SALE_DIRECTION.SALE_DIRECTION_OUT ? PRODUCT_TYPE.PRODUCT_TYPE_SALE : PRODUCT_TYPE.PRODUCT_TYPE_PURCHASE;
  }

  updateTotalPrices() {
    this.formGroup.controls.totalPriceVatExcluded.setValue(this.roundNumber(this.formGroup.controls.unitPriceVatExcluded.value * this.formGroup.controls.quantity.value));
    this.formGroup.controls.totalPriceVatIncluded.setValue(this.roundNumber(this.formGroup.controls.unitPriceVatIncluded.value * this.formGroup.controls.quantity.value));
  }

  private roundNumber(value: number): number {
    return Math.round(value * 100) / 100;
  }


  add() {
    const saleProduct: SaleSavePayloadProduct = this.formGroup.value;
    saleProduct.totalPriceVatExcluded = this.formGroup.get('totalPriceVatExcluded').value;
    saleProduct.totalPriceVatIncluded = this.formGroup.get('totalPriceVatIncluded').value;
    this.service.executeAction({
      saleProduct,
      id: this.dialog.input.sale.id
    }).then(value => this.dialog.close(value))
        .catch(e => this.toastControl.presentError(e));
  }

  get isSimple(): boolean {
    return false;
  }
}
